export interface JwtUserClaims {
    sub?: string | number;
    email?: string;
    is_admin?: boolean;
}

export function decodeJwtPayload(token: string): JwtUserClaims | null {
    const parts = token.split(".");
    if (parts.length < 2) {
        return null;
    }

    try {
        const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
        const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), "=");
        const json = atob(padded);
        return JSON.parse(json) as JwtUserClaims;
    } catch {
        return null;
    }
}

export function readIsAdminFromToken(token: string | null): boolean {
    if (!token) {
        return false;
    }

    const claims = decodeJwtPayload(token);
    return claims?.is_admin === true;
}
